// Reject invalid edits instead of turning e.g. 1-1 into 11.
export const isTransactionIdInput = (value: string, multiple = false) =>
  multiple
    ? /^ *(?:\d+ *(?:, *\d+ *)*,? *)?$/.test(value)
    : /^\d*$/.test(value);

export const transactionIdSetter =
  (setValue: (value: string) => void, multiple = false) =>
  (value: string) => {
    if (
      isTransactionIdInput(value, multiple) &&
      value
        .split(",")
        .every((id) => !id.trim() || Number.isSafeInteger(Number(id)))
    ) {
      setValue(value);
    }
  };

export const parseTransactionIds = (value: string): number[] => {
  if (!isTransactionIdInput(value, true))
    throw new Error("Invalid transaction ID filter");
  return value
    .split(",")
    .map((id) => id.trim())
    .filter(Boolean)
    .map((id) => {
      const number = Number(id);
      if (!Number.isSafeInteger(number))
        throw new Error("Invalid transaction ID");
      return number;
    });
};
